<template>
    <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Gereciamento Tipo Obras</span>
                <br/>
                <span class="navigation">Tipo Obras > Cadastro</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <form name="form" @submit.prevent="onSubmit">
            <div>
              <template v-if="validation.hasError('tipoObra.nome')">
                <InlineMessage>{{ validation.firstError('tipoObra.nome') }}</InlineMessage>
              </template>
            </div>
            <div class="row">
              <div class="col-md-6 mb-2">
                <label for="nome">Nome:</label>
                <span class="p-fluid">
                  <InputText
                    type="text"
                    id="marca"
                    v-model="tipoObra.nome"
                    :class="{'p-error': validation.hasError('tipoObra.nome')}"
                  />
                </span>
              </div>
            </div>
            <hr />
            <template>
              <Button
                label="Gravar"
                title="Gravar"
                type="submit"
                class="p-button-primary mr-2 p-button-success"
                icon="pi pi-check"
                :disabled="loading"
              >
              </Button>
              <router-link to="/tipoObraConsulta">
                <Button
                  label="Voltar"
                  title="Voltar"
                  type="button"
                  class="p-button-primary mr-2"
                  icon="pi pi-arrow-left"
                  :disabled="loading"
                ></Button>
              </router-link>
            </template>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginService from "../services/acesso/login.service";
import TipoObra from '../models/obras/TipoObra';
import SimpleVueValidation from "simple-vue-validator";
import tipoObraService from '../services/obras/tipo.obra.service';
const Validator = SimpleVueValidation.Validator;

export default {
  name: 'TipoObraCadastro',
  data() {
    return{
      loading: false,
      tipoObra: new TipoObra()
    }
  },
  created(){
    this.currentUser = LoginService.currentUserValue;
    this.id = this.$route.params.idTipoObra;

      if(this.id != null){
        setTimeout(async() => {
          await tipoObraService.getTipoObra(this.id).then(
            response=>{
              this.tipoObra = response.data;
            },
            error=>{
              let errorMessage = "Houve um problema ao buscar Tipo Obra!";
              if(error.response){
                errorMessage = error.response.data;
              }
              this.$toast.add({
                severity: "error",
                summary: errorMessage
              });
            }
          )
        },250)
      }
  },
  validators: {
    "tipoObra.nome": function(value){
      return Validator.value(value)
      .required("Nome Obrigatório")
      .maxLength(200, "Deve ser menor ou igual a 200")
    }
  },
  methods: {
    onSubmit(){
      this.loading = true;
      this.$validate().then(success => {
        if(success){
          this.salvar();
        }
      });
      this.loading = false;
    },
    salvar(){
      this.tipoObra.idCliente = this.currentUser.usuario.idCliente;
      tipoObraService.saveTipoObra(this.tipoObra).then(
        data => {
          console.log(data);
          this.$toast.add({
            severity: "success",
            summary: "Tipo Obra salvo com sucesso"
          });
          this.$router.push("tipoObraConsulta");
        },
        error => {
          let errorMessage = "Houve um erro ao salvar o Tipo Obra!";
          if(error.response){
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
    },
    limparForm(){
      this.tipoObra.nome = '';
    }
  }
}
</script>